import './Header.css';
import { isString } from 'lodash';
function Header({title, children}) {
    return (
        <div className="page-bar">
            <div className="title">{isString(title) ? decodeURI(title) : title}</div>
            <div className="buttons">{children}</div>
        </div>
    )
}

export default Header;